import { render, staticRenderFns } from "./memberMaritalStatus.vue?vue&type=template&id=02ba3685&"
import script from "./memberMaritalStatus.vue?vue&type=script&lang=js&"
export * from "./memberMaritalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports